const slides = document.querySelectorAll('.slide');
const bullets = document.querySelectorAll('.bullet');
let index = 0;
const total = slides.length;
const slideDuration = 6000; // 6 seconds per slide

function showSlide(i){
  slides.forEach(slide => slide.classList.remove('active'));
  bullets.forEach(b => b.classList.remove('active'));
  slides[i].classList.add('active');
  bullets[i].classList.add('active');
}

// Click on bullets
bullets.forEach((bullet) => {
  bullet.addEventListener('click', () => {
    index = parseInt(bullet.getAttribute('data-slide'));
    showSlide(index);
  });
});

// Auto-slide
setInterval(() => {
  index = (index < total - 1) ? index + 1 : 0;
  showSlide(index);
}, slideDuration);

// Initial load
showSlide(index);